import { render, staticRenderFns } from "./AuthCourse.vue?vue&type=template&id=848b3dbe&scoped=true&"
import script from "./AuthCourse.vue?vue&type=script&lang=js&"
export * from "./AuthCourse.vue?vue&type=script&lang=js&"
import style0 from "./AuthCourse.vue?vue&type=style&index=0&id=848b3dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848b3dbe",
  null
  
)

export default component.exports